import dateToString from '@ps-int/ufo-helpers/lib/date/date-to-string';
import { FetchError } from '@yandex-360/telemost-sdk';
import { call, put, select } from 'typed-redux-saga';

import { NOTIFICATIONS_MAP, notify } from '../../../shared/features/notifications/ps-notifications';
import { cloudApi } from '../../../shared/helpers/transport';
import { NotificationId } from '../../call/types';
import { selectSelectedSession } from '../selectors';

export function* downloadReportSaga() {
    const selectedSession = yield* select(selectSelectedSession);
    if (!selectedSession) return;
    const formattedStartedDate = dateToString(new Date(selectedSession.startedAt), 'DD.MM.YY HH-mm');
    const filename = `Участники встречи № ${selectedSession.shortUrlId} от ${formattedStartedDate}.xlsx`;
    try {
        const reportBlob = yield* call(
            [cloudApi, cloudApi.getSessionReport],
            selectedSession.shortUrlId,
            selectedSession.sessionId
        );
        const reportUrl = URL.createObjectURL(reportBlob);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style.display = 'none';
        a.href = reportUrl;
        a.download = filename;
        a.click();
        document.body.removeChild(a);
    } catch (error) {
        if (FetchError.is(error)) {
            yield* put(notify(NOTIFICATIONS_MAP[NotificationId.REPORT_ERROR]()));
        }
    }
}
